import { VitePWAOptions } from "vite-plugin-pwa";


export const manifestForPlugIn: Partial<VitePWAOptions> = {
  registerType: "autoUpdate",
  manifestFilename: 'manifest.webmanifest',
  devOptions: {
    enabled: true,
  },
  manifest: {
    name: "Leonext",
    short_name: "Leonext",
    description: "App for crypto and fiat transactions",
    screenshots:  [
      {
        src: "/screenshot-3.png",
        sizes: "1918x868",
        type: "image/png",
        // form_factor: "wide",
      },
      {
        src: "/screenshot-4.png",
        sizes: "800x868",
        type: "image/png",
        // form_factor: "narrow",
      },
    ],
    icons:  [
      {
        src: "/android-chrome-192x192.png",
        sizes: "192x192",
        type: "image/png",
        purpose: "favicon",
      },
      {
        src: "/android-chrome-512x512.png",
        sizes: "512x512",
        type: "image/png",
        purpose: "favicon",
      },
      {
        src: "/apple-touch-icon.png",
        sizes: "180x180",
        type: "image/png",
        purpose: "apple touch icon",
      },
      {
        src: "/maskable_icon.png",
        sizes: "512x512",
        type: "image/png",
        purpose: "any maskable",
      },
      {
        src: "/f-144x144.png",
        sizes: "144x144",
        type: "image/png",
        purpose: "any",
      },
    ],
    theme_color: "#171717",
    background_color: "#f0e7db",
    display: "standalone",
    scope: "/",
    start_url: "/pos/login",
    orientation: "portrait",

  },

  workbox: {
    skipWaiting: true,
    clientsClaim: true,
    globDirectory: "dist",
    navigateFallback: "/index.html",
    globPatterns: ["**/*.{js,css,html,ico,png,svg}"],
    navigateFallbackDenylist: [/^\/api/, /^\/media/], // exclude /media from navigation fallback
    globIgnores: ["**/media/**"], // exclude from precache
    maximumFileSizeToCacheInBytes: 50 * 1024 * 1024, // 50 MiB
    runtimeCaching: [
      // General app cache (excluding /api and /media)
      {
        urlPattern: ({ url }: { url: URL }) =>
          !url.pathname.startsWith("/api") &&
          !url.pathname.startsWith("/media"),
        handler: "CacheFirst",
        options: {
          cacheName: "app-cache",
          expiration: {
            maxEntries: 100,
            maxAgeSeconds: 60 * 60 * 24 * 7,
          },
        },
      },
    ],
  },
};
